import { createSlice } from '@reduxjs/toolkit'
import type { VehicleType } from '@view/contexts/FodContainerContext/types'
import type { RootState } from '..'
import { updateAddress, updateSameAddress } from './resLocationsSlice'
import { setDisplayBackToRentalButton } from './resUiSlice'
import { updateEndDate, updateResTimes, updateStartDate } from './resEditFormSlice'

export interface ResVehicleState {
	businessVehicleDefaults: string[] | []
	businessVehicleDefault: null | string
	vehicleDetails: null | VehicleType
	vehicleGroupId: null | string
	businessVehicleCodesReact: {
		[key: string]: VehicleType[]
	}
	fodRideVehicles: boolean
	poolFleetVehicles: boolean
}
const initialState: ResVehicleState = {
	vehicleGroupId: null,
	vehicleDetails: {},
	businessVehicleDefault: null,
	businessVehicleDefaults: [],
	businessVehicleCodesReact: null,
	fodRideVehicles: false,
	poolFleetVehicles: false,
	selectedPoolFleetVehicle: null,
}

export const reservationVehicleSlice = createSlice({
	name: 'resVehicle',
	initialState,
	reducers: {
		setSelectedPoolFleetVehicle(state, action) {
			const { selectedLocationVehicles, vehicleId } = action.payload
			const [selectedPoolFleetVehicle] = selectedLocationVehicles.filter(vehicle => vehicle.id == vehicleId)
			state.selectedPoolFleetVehicle = selectedPoolFleetVehicle
			state.vehicleDetails = { ...selectedPoolFleetVehicle, code: selectedPoolFleetVehicle.modelDescription }
			state.vehicleGroupId = selectedPoolFleetVehicle.vehicleGroupId
		},
		setPoolFleetVehicles(state, action) {
			state.poolFleetVehicles = action.payload

			if (!action.payload) {
				state.selectedPoolFleetVehicle = null
			}
		},
		setVehicleGroup(state, action) {
			state.vehicleGroupId = action.payload.id
			state.vehicleDetails = action.payload

			if (!action.payload.taxiVehicle) {
				state.rentalVehicle = action.payload
			}
		},

		//TODO - remove after back end api is built for fod ride
		setFodRideVehicles(state, action) {
			state.fodRideVehicles = action.payload
		},
	},
	extraReducers(builder) {
		builder.addCase(setDisplayBackToRentalButton, (state, _action) => {
			state.vehicleGroupId = state.rentalVehicle.id
			state.vehicleDetails = state.rentalVehicle
		}),
			builder.addCase(updateAddress, (state, _action) => {
				state.selectedPoolFleetVehicle = null
			})
		builder.addCase(updateSameAddress, (state, _action) => {
			state.selectedPoolFleetVehicle = null
		})
		builder.addCase(updateStartDate, (state, _action) => {
			state.selectedPoolFleetVehicle = null
		})
		builder.addCase(updateEndDate, (state, _action) => {
			state.selectedPoolFleetVehicle = null
		})
		builder.addCase(updateResTimes, (state, _action) => {
			state.selectedPoolFleetVehicle = null
		})
	},
})
export const reservationVehicleSliceReducer = reservationVehicleSlice.reducer
export const selectResVehicle = (state: RootState) => state.vehicle
export const { setVehicleGroup, setFodRideVehicles, setPoolFleetVehicles, setSelectedPoolFleetVehicle } = reservationVehicleSlice.actions
